import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton, Typography, MenuItem, TextField, Box } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
import AxiosInstance from "service/axiosInstance";
import { useToast } from "hooks";
import { useGetActiveDevices } from "pages/ManageDevices/deviceQueries";

const DeleteDialogModal = styled(Dialog)((props) => {
  return {
    "& .MuiPaper-root": {
      padding: "40px 40px 20px ",
    },
  };
});

export default function DeleteDialog({
  content,
  open,
  type,
  handleCancelDelete,
  handleConfirmDelete,
}) {
  return (
    <div>
      <DeleteDialogModal
        open={open}
        //onClose={handleCancelDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="!px-0"
      >
        {/* <DialogTitle className="flex justify-between items-center">
          <span>
            <IconButton onClick={handleCancelDelete}>
              <CloseIcon fontSize={"medium"} style={{ color: "#434349" }} />
            </IconButton>
          </span>
        </DialogTitle> */}
        <DialogContent id="alert-dialog-title">
          <Typography variant="subtitle1">
            Are you sure you want to delete this {type}?
          </Typography>
        </DialogContent>

        <DialogActions className="mt-4 mb-3 flex justify-between">
          <Button
            variant="outlined"
            size="large"
            fullWidth
            onClick={handleCancelDelete}
          >
            Close
          </Button>
          <Button
            variant="contained"
            size="large"
            onClick={handleConfirmDelete}
            fullWidth
          >
            Delete
          </Button>
          {/*           
          <SecondaryButton onClick={handleCancelDelete}>Close</SecondaryButton>
          <PrimaryButton onClick={handleConfirmDelete}>
            Delete
          </PrimaryButton> */}
        </DialogActions>
      </DeleteDialogModal>
    </div>
  );
}

/**
 * DeleteConfirmDialog — transaction-specific delete confirmation dialog.
 * Requirements: 3.1, 3.2, 3.3, 3.4
 */
export function DeleteConfirmDialog({ isOpen, onClose, transactionId, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [deviceId, setDeviceId] = useState("");
  const { toastError } = useToast();
  const { data: activeDevicesData } = useGetActiveDevices();
  const activeDevicesList = activeDevicesData?.data ?? [];

  const handleConfirm = async () => {
    setLoading(true);
    try {
      let url = `api/v1/transaction/${transactionId}`;
      if (deviceId) {
        url += `?deviceId=${encodeURIComponent(deviceId)}`;
      }
      await AxiosInstance({
        method: "DELETE",
        url,
      });
      setDeviceId("");
      onClose();
      if (onSuccess) onSuccess();
    } catch (err) {
      const message =
        err?.message || err?.error || "Failed to delete. Please try again.";
      toastError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DeleteDialogModal
      open={isOpen}
      aria-labelledby="delete-confirm-dialog-title"
      aria-describedby="delete-confirm-dialog-description"
    >
      <DialogContent id="delete-confirm-dialog-description">
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          Are you sure you want to delete this entry?
        </Typography>
        <Box sx={{ mt: 2, minWidth: 200 }}>
          <TextField
            id="outlined-select-device-delete"
            select
            fullWidth
            label="Device ID (Optional)"
            value={deviceId}
            onChange={(e) => setDeviceId(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                height: "50px",
                borderRadius: "10px",
              },
            }}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {activeDevicesList.map((dev) => (
              <MenuItem key={dev.id} value={dev.deviceId}>
                {dev.name} ({dev.deviceId})
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </DialogContent>
      <DialogActions className="mt-4 mb-3 flex justify-between">
        <Button
          variant="outlined"
          size="large"
          fullWidth
          onClick={() => {
            setDeviceId("");
            onClose();
          }}
          data-testid="cancel-button"
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          size="large"
          fullWidth
          onClick={handleConfirm}
          data-testid="confirm-button"
          disabled={loading}
        >
          {loading ? "Deleting..." : "Delete"}
        </Button>
      </DialogActions>
    </DeleteDialogModal>
  );
}
